/* eslint semi:0 */
import {
  authenticated,
  autnenticationFailed,
  reauthenticated,
} from '../../organizedByType/actions/userToolbarActions'
import { warn } from '../../application/console'
import { external } from '../../utils/script'
import { safeRequest } from '../../utils/mithril'

const FB_CONNECT_URL = '/auth/facebook/callback'
let facebook = external.load({ name: 'facebook' })

let facebookAuthenticationProvider = {
  //eslint-disable-line no-unused-vars

  login() {
    facebook(() =>
      window.FB.login(this.handleLoginResponse.part(authenticated), {
        scope: 'public_profile,email',
      })
    )
  },

  handleLoginResponse(successCallback, response) {
    if (response.status === 'connected' && response.authResponse) {
      safeRequest({
        method: 'GET',
        url: FB_CONNECT_URL,
        data: { signed_request: response.authResponse.signedRequest }, //eslint-disable-line camelcase
      }).then(successCallback, autnenticationFailed)
    } else {
      autnenticationFailed(response) //TODO: probably should be an independent action
    }
  },

  reAuthenticate() {
    facebook(() => window.FB.getLoginStatus(this.handleLoginResponse.part(reauthenticated)))
  },
}

export { facebookAuthenticationProvider }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/facebook/facebookAuthenticationProvider.js